import { isAppStateReady } from 'src/state/store'
import { defer } from 'react-router-dom'

export default async function loader() {
  await isAppStateReady()

  return defer({ data: Promise.resolve(true) })
}
